const tableStyle = theme => ({
    table: {
        width: '100%',
        '& .MuiPaper-root': {
            fontSize: '1em'
        },
        '& .MuiTableCell-root': {
            padding: '5px'
        }
    }
});

export default tableStyle;